/* eslint-disable complexity */
import _ from 'lodash';
import React from 'react';
import { Button, Divider, Tag } from 'src/@vymo/ui/atoms';
import Text from 'src/@vymo/ui/atoms/text';
import { Card, NoData } from 'src/@vymo/ui/blocks';
import { ReactComponent as AlertIcon } from 'src/assets/icons/alertFill.svg';
import { ReactComponent as CalendarIcon } from 'src/assets/icons/calendar.svg';
import { ReactComponent as CheckIcon } from 'src/assets/icons/checkIcon.svg';
import { ReactComponent as ClockIcon } from 'src/assets/icons/clock.svg';
import { ReactComponent as FocusIcon } from 'src/assets/icons/focusFill.svg';
import { ReactComponent as NotificationIcon } from 'src/assets/icons/notificationFill.svg';
import { ReactComponent as HistoryIcon } from 'src/assets/icons/reset.svg';
import { ReactComponent as RssFillIcon } from 'src/assets/icons/rssFill.svg';
import { ReactComponent as SelectedIcon } from 'src/assets/icons/selectedAction.svg';
import { Keys, locale } from 'src/i18n';
import { processSuggestions } from './queries';
import styles from './index.module.scss';

function Suggestions({ data = { suggestions: [] }, card }) {
  const suggestionsData: {
    ctas: any;
    title: string;
    message: string;
    dateText: string;
    tagText: string;
    tagColor: string;
    iconResource: string;
  }[] = processSuggestions(data.suggestions || []);

  const getIconForSuggestion = (displayIcon) => {
    switch (displayIcon) {
      case 'calendar':
        return <CalendarIcon style={{ color: '#DD2E44' }} />;
      case 'follow_up':
        return <HistoryIcon style={{ color: '#616CBF' }} />;
      case 'alert':
        return <AlertIcon style={{ color: '#FFAC33' }} />;
      case 'nba':
        return <SelectedIcon style={{ color: '#226699' }} />;
      case 'reminder':
        return <ClockIcon style={{ color: '#55ACEE' }} />;
      case 'goal':
        return <FocusIcon style={{ color: '#C04040' }} />;
      case 'approval':
        return <CheckIcon style={{ color: '#226699' }} />;
      case 'broadcast':
        return <RssFillIcon style={{ color: '#4CBD6E' }} />;
      case 'offers':
      case 'recommendation':
      case 'notification':
      default:
        return <NotificationIcon style={{ color: '#F2AB78' }} />;
    }
  };

  return (
    <>
      <div className={styles.lastEngagementHeader}>
        <Text semiBold type="h5">
          {card.name}
        </Text>
      </div>
      {suggestionsData.length === 0 && (
        <NoData
          message={locale(Keys.NO_DATA_FOUND_FOR_CARD, { cardName: card.name })}
        />
      )}
      <div className={styles.suggestionsWrapper}>
        {suggestionsData.map((suggestion) => (
          <Card classNames={styles.suggestionsWrapper__card}>
            {suggestion.tagText && (
              <Tag className={styles.suggestionsWrapper__card__tag}>
                {_.upperCase(suggestion.tagText)}
              </Tag>
            )}
            <div className={styles.suggestionsWrapper__card__infoWrapper}>
              <span>{getIconForSuggestion(suggestion.iconResource)}</span>
              <div
                className={styles.suggestionsWrapper__card__infoWrapper__info}
              >
                {suggestion.title && <Text semiBold>{suggestion.title}</Text>}
                <Text type="label">
                  <p
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: suggestion?.message }}
                  />
                </Text>
              </div>
            </div>
            {suggestion.ctas?.length > 0 && (
              <>
                <Divider />
                <div className={styles.suggestionsWrapper__card__ctaWrapper}>
                  {suggestion.ctas.map((cta) => (
                    <Button type="text">
                      <Text type="sublabel" semiBold>
                        {_.upperCase(cta.text)}
                      </Text>
                    </Button>
                  ))}
                </div>
              </>
            )}
          </Card>
        ))}
      </div>
    </>
  );
}

export default Suggestions;
